import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';


export default function UnauthorizedPage() {
  return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Typography variant="h2" component="h1" gutterBottom>
            Access Denied.
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom>
            {`You don't have permission to access this page.  `}
            {`Please contact your administrator.`}

          </Typography>
        </Container>

      </Box>
  );
}